import { render, staticRenderFns } from "./domain-settings.vue?vue&type=template&id=cfb6b44a"
import script from "./domain-settings.vue?vue&type=script&lang=js"
export * from "./domain-settings.vue?vue&type=script&lang=js"
import style0 from "./domain-settings.vue?vue&type=style&index=0&id=cfb6b44a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports